module.exports = __webpack_public_path__ + "img/3.c617db4d.jpg";